<div
  class="fit-height full-width-container main-flex-container"
  [ngStyle]="{
    'max-height': getTableHeight(),
    'padding-bottom': getTablePadding()
  }"
>
  <div
    class="row"
    [ngStyle]="{
      margin: claimsToReview.length > 0 ? '10px 0' : '20px 0'
    }"
  >
    <div class="col-sm" style="padding-right: 0px !important">
      <div
        *ngIf="claimsToReview.length > 0"
        class="claim-alert"
        style="margin-bottom: 18px"
      >
        <span style="margin-right: 5px"
          >{{ claimsToReview.length }} Claims to review</span
        >
        <img
          src="assets/images/icons/alert-circle-outline.png"
          alt="Search"
          style="width: 15px; height: 15px; margin: 2px 5px 0 0"
        />
      </div>
    </div>
  </div>

  <!--style="overflow-y: auto"height: 450px;-->
  <div class="main-content">
    <div class="example-container">
      <div class="mat-table-scroll-wrapper">
        <!-- <table mat-table [dataSource]="getTableRows()" multiTemplateDataRows> -->
        <table
          mat-table
          [dataSource]="tableRows"
          multiTemplateDataRows
          class="mat-elevation-z8"
          style="box-shadow: none"
        >
          <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"> -->
          <ng-container matColumnDef="checkbox">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="position: sticky; top: 0"
              class="checkbox-col"
            >
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                style="margin-left: -4px !important; padding-right: 10px"
                [ngStyle]="{
                  'margin-bottom':
                    (!showQualifierSearch && qualifierFilter.value) ||
                    (!showStatementSearch && textFilter.value) ||
                    (!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '15px'
                      : null
                }"
              >
              </mat-checkbox>
            </th>
            <td
              mat-cell
              *matCellDef="let row; let i = index"
              class="checkbox-col"
            >
              <ng-container *ngIf="!row.isExpansion">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleRowSelection(row) : null"
                  [checked]="selection.isSelected(row)"
                  style="padding-right: 5px"
                >
                </mat-checkbox>
              </ng-container>
            </td>
          </ng-container>

          <!-- Sl.No Column -->
          <ng-container matColumnDef="slno">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="position: sticky; top: 0"
            >
              <div
                [ngStyle]="{
                  'margin-bottom':
                    (!showQualifierSearch && qualifierFilter.value) ||
                    (!showStatementSearch && textFilter.value) ||
                    (!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '20px'
                      : null
                }"
              >
                Sl.No.
              </div>
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              style="padding-left: 0px !important"
            >
              <div style="display: flex; align-items: center; min-height: 19px">
                <!-- Reserve space for the icon, even if not present -->
                <ng-container
                  *ngIf="element.review_claim; else iconPlaceholder"
                >
                  <img
                    src="assets/images/icons/alert-circle-outline.png"
                    alt="Search"
                    style="
                      width: 15px;
                      height: 15px;
                      margin: 0px 5px 0 0;
                      cursor: pointer;
                    "
                    (click)="claimReviewPopup(element, i)"
                  />
                </ng-container>
                <ng-template #iconPlaceholder>
                  <span
                    style="
                      display: inline-block;
                      width: 15px;
                      height: 15px;
                      margin: 2px 5px 0 0;
                    "
                  ></span>
                </ng-template>
                <span>{{ element.slno }}</span>
              </div>
            </td>
          </ng-container>
          <!--Statement Text Column-->
          <ng-container matColumnDef="text">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="position: sticky; top: 0"
              appClickOutside
              (clickOutside)="showStatementSearch = false"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 300px;
                "
                [ngStyle]="{
                  'margin-bottom':
                    ((!showQualifierSearch && qualifierFilter.value) ||
                      (!showMarketingFilter &&
                        marketingFilter.value?.length > 0)) &&
                    !(!showStatementSearch && textFilter.value)
                      ? '20px'
                      : null
                }"
              >
                <!-- Statement Text Header -->
                <span [ngClass]="{ 'header-text-highlight': textFilter.value }">
                  {{
                    selectedView === "local"
                      ? "Statement Text"
                      : "Global Statement Text"
                  }}
                </span>

                <img
                  src="assets/images/icons/search.svg"
                  alt="Search"
                  style="
                    width: 13px;
                    height: 13px;
                    cursor: pointer;
                    margin-top: 3px;
                  "
                  (click)="toggleStatementSearch()"
                />
              </div>

              <!-- Statement Text
          <mat-icon class="text-icon" (click)="toggleStatementSearch()"
            >search</mat-icon
          > -->
              <div
                *ngIf="showStatementSearch"
                class="flex justify-between items-center input-container"
              >
                <div class="flex search-container">
                  <img src="assets/images/icons/search.svg" />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="textFilter"
                  />
                  <img
                    *ngIf="textFilter.value"
                    (click)="clearSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="cursor: pointer"
                  />
                </div>
              </div>
              <!--To show case seached text-->
              <div
                *ngIf="!showStatementSearch && textFilter.value"
                class="search-badge"
              >
                <span class="search-text">{{ textFilter.value }}</span>
                <img
                  (click)="clearSearch()"
                  src="assets/images/icons/close-icon.png"
                  class="close-icon"
                />
              </div>
            </th>

            <!-- to make it disabled  [disabled]="true" -->
            <td mat-cell *matCellDef="let element; let i = index">
              <div style="position: relative; width: 100%">
                <!-- add when we have cloud icon paddingRight: isTruncated ? '40px' : '60px' -->
                <!-- height: isTruncated ? '6vh' : '6vh', -->
                <!-- <textarea
                  #textAreaRef
                  matInput
                  [(ngModel)]="element.text"
                  class="txt-area-statement"
                  [matTooltip]="element.text"
                  (ngModelChange)="onTextInput(element)"
                  [ngStyle]="{
                    
                     height: isTruncated ? '3.4em' : '3.4em',
                    overflow: isTruncated ? 'auto' : 'hidden',
                    resize: 'none',
                    
                  }"
                  class="txt-area-statement"
                  style="width: 100%; z-index: 1; cursor: not-allowed"
                  [disabled]="true"
                ></textarea> -->

                <textarea
                  #textAreaRef
                  matInput
                  [(ngModel)]="
                    selectedView === 'local' ? element.text : element.globalText
                  "
                  class="txt-area-statement"
                  [matTooltip]="
                    selectedView === 'local' ? element.text : element.globalText
                  "
                  (ngModelChange)="onTextInput(element)"
                  [ngStyle]="{
                    height: isTruncated ? '3.4em' : '3.4em',
                    overflow: isTruncated ? 'auto' : 'hidden',
                    resize: 'none'
                  }"
                  style="width: 100%; z-index: 1; cursor: not-allowed"
                  [disabled]="true"
                ></textarea>
                <img
                  *ngIf="element.isEdited"
                  src="assets/images/icons/close.png"
                  alt="Clear"
                  class="clear-icon"
                  (click)="clearText(element)"
                />
                <img
                  *ngIf="element.isEdited"
                  src="assets/images/icons/content-save-outline.png"
                  class="content-save-outline"
                  (click)="
                    element.text.trim() !== '' &&
                      getGlobalQualifiersMarketingChannels($event, element.slno)
                  "
                  alt="Save"
                />
              </div>
            </td>
          </ng-container>

          <!-- Qualifier Column -->
          <ng-container matColumnDef="qualifier">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0"
              appClickOutside
              (clickOutside)="showQualifierSearch = false"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 180px;
                "
                [ngStyle]="{
                  'margin-bottom':
                    ((!showStatementSearch && textFilter.value) ||
                      (!showMarketingFilter &&
                        marketingFilter.value?.length > 0)) &&
                    !(!showQualifierSearch && qualifierFilter.value)
                      ? '20px'
                      : null
                }"
              >
                <!-- <span>{{ tableHeaders[selected].qualifier }}</span> -->

                <!-- Qualifier Header -->
                <span
                  [ngClass]="{ 'header-text-highlight': qualifierFilter.value }"
                >
                  {{
                    selectedView === "local"
                      ? "Qualifier/Disclaimer"
                      : "Global Qualifier/Disclaimer"
                  }}
                </span>

                <img
                  src="assets/images/icons/search.svg"
                  alt="Search"
                  style="
                    width: 13px;
                    height: 13px;
                    cursor: pointer;
                    margin-top: 3px;
                  "
                  (click)="toggleQualifierSearch()"
                />
              </div>

              <!-- <mat-icon class="qualifier-icon" (click)="toggleQualifierSearch()"
            >search</mat-icon
          > -->

              <div
                *ngIf="showQualifierSearch"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 14% !important"
                >
                  <img src="assets/images/icons/search.svg" />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="qualifierFilter"
                  />
                  <!-- <mat-icon
          *ngIf="filterQualifierValue"
          class="mat-icon-lang-clear"
          >clear</mat-icon
        > -->
                  <img
                    (click)="clearQualifierSearch()"
                    *ngIf="qualifierFilter.value"
                    src="assets/images/icons/close-icon.png"
                    style="cursor: pointer"
                  />
                </div>
              </div>
              <!--To show case seached text-->
              <div
                *ngIf="!showQualifierSearch && qualifierFilter.value"
                class="search-badge"
              >
                <span class="search-text">{{ qualifierFilter.value }}</span>
                <img
                  (click)="clearQualifierSearch()"
                  src="assets/images/icons/close-icon.png"
                  class="close-icon"
                />
              </div>
            </th>

            <td mat-cell *matCellDef="let element; let i = index">
              <!-- Show dropdown if qualifiers exist and formatting is not applied -->
              <ng-container
                *ngIf="new_qualifier?.length && !isFormatted; else formattedTpl"
              >
                <mat-form-field
                  appearance="outline"
                  style="width: 200px !important"
                >
                  <mat-select
                    [(ngModel)]="element.qualifier"
                    placeholder="Select Qualifier"
                    multiple
                    [matTooltip]="element.qualifier"
                  >
                    <mat-option
                      *ngFor="let qual of new_qualifier"
                      [value]="qual"
                    >
                      <span [innerHTML]="sanitizeHTML(qual)"></span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <!-- Show formatted content -->
              <ng-template #formattedTpl>
                <!-- Show textarea if richtext is not enabled -->
                <ng-container *ngIf="!element.richtext; else richTextTpl">
                  <!-- <textarea
                    matInput
                    class="txt-area txt-area-qualifier"
                    [readonly]="!isFormatted"
                    [disabled]="true"
                    style="
                      resize: none;
                      height: 3.4em;
                      width: 100%;
                      border: 1px solid #8a8a8a;
                      border-radius: 3px;
                      font-family: Unilever Shilling;
                      font-size: 10px;
                      color: #49526e;
                      padding: 3px;
                      cursor: not-allowed;
                    "
                    [ngModel]="sanitizeHTML(element.qualifier) || ''"
                    (click)="enableEditor(element, i)"
                    [matTooltip]="element.qualifier"
                  ></textarea> -->
                  <textarea
                    matInput
                    class="txt-area txt-area-qualifier"
                    [readonly]="!isFormatted"
                    [disabled]="true"
                    style="
                      resize: none;
                      height: 3.4em;
                      width: 100%;
                      border: 1px solid #8a8a8a;
                      border-radius: 3px;
                      font-family: Unilever Shilling;
                      font-size: 10px;
                      color: #49526e;
                      padding: 3px;
                      cursor: not-allowed;
                    "
                    [ngModel]="
                      sanitizeHTML(
                        selectedView === 'local'
                          ? element.qualifier
                          : element.globalQualifier
                      ) || ''
                    "
                    (click)="enableEditor(element, i)"
                    [matTooltip]="
                      selectedView === 'local'
                        ? element.qualifier
                        : element.globalQualifier
                    "
                  ></textarea>
                </ng-container>

                <!-- Show rich text editor -->
                <ng-template #richTextTpl>
                  <editor
                    [(ngModel)]="element.qualifier"
                    [init]="init"
                    [disabled]="element.isEdited"
                    class="editor-class"
                  ></editor>
                </ng-template>
              </ng-template>
            </td>
          </ng-container>

          <!-- Marketing Channel Column -->
          <ng-container matColumnDef="marketing_channels">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0"
              class="marketing-channel-col"
              appClickOutside
              (clickOutside)="showMarketingFilter = false"
            >
              <span
                style="display: flex; align-items: center"
                [ngClass]="{
                  'header-text-highlight': marketingFilter.value?.length > 0
                }"
                [ngStyle]="{
                  'margin-bottom':
                    ((!showStatementSearch && textFilter.value) ||
                      (!showQualifierSearch && qualifierFilter.value)) &&
                    !(!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '20px'
                      : null
                }"
              >
                Marketing Channel
                <img
                  src="assets/images/icons/Vector.svg"
                  style="
                    margin-top: 3px;
                    margin-left: 55px;
                    height: 12px;
                    width: 12px;
                    cursor: pointer;
                  "
                  (click)="toggleMarketingFilter()"
                />
              </span>

              <div
                *ngIf="showMarketingFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 13% !important"
                >
                  <mat-select
                    [formControl]="marketingFilter"
                    [multiple]="true"
                    placeholder="Select channels"
                    style="margin-top: 10px !important"
                  >
                    <mat-option
                      *ngFor="let option of options_marketing"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>

              <div
                *ngIf="showMarketingFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 13% !important"
                >
                  <mat-select
                    #marketingDropdown
                    [formControl]="marketingFilter"
                    (closed)="onMarketingChannelDropdownClosed()"
                    [multiple]="true"
                    placeholder="Select channels"
                    style="width: 100%; margin-top: 0px !important"
                    panelClass="custom-marketing-dropdown"
                  >
                    <mat-option
                      *ngFor="let option of options_marketing"
                      [value]="option"
                      panelClass="custom-marketing-dropdown"
                      style="font-size: 10px; width: 100%"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
              <!--To show case seached text-->
              <div
                *ngIf="
                  !showMarketingFilter && marketingFilter.value?.length > 0
                "
                class="search-badge-marketing"
              >
                <div class="search-items-marketing">
                  <ng-container
                    *ngFor="let item of marketingFilter.value; let i = index"
                  >
                    <span class="search-text-marketing">
                      {{ item }}
                      <img
                        *ngIf="i === marketingFilter.value.length - 1"
                        (click)="clearMarketingFilterSearch()"
                        src="assets/images/icons/close-icon.png"
                        class="close-icon"
                      />
                    </span>
                  </ng-container>
                </div>
              </div>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="marketing-channel-col"
            >
              <mat-form-field appearance="outline" class="w-full">
                <mat-select
                  [(ngModel)]="element.marketing_channels"
                  [panelClass]="'my-select-panel'"
                  multiple
                  [matTooltip]="element.marketing_channels"
                >
                  <mat-option
                    *ngFor="let option of options_marketing"
                    [value]="option"
                    [disabled]="true"
                    style="font-size: 10px"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>

            <!-- <td mat-cell *matCellDef="let element">
              <mat-form-field appearance="outline" class="w-full">
                <mat-select [(ngModel)]="element.marketing_channels" multiple>
                  <mat-option
                    *ngFor="let option of options_marketing"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td> -->
          </ng-container>

          <!-- <ng-container matColumnDef="marketing_channel">
        <th mat-header-cell *matHeaderCellDef>
          <div>
            <span>Marketing Channel</span>
            <img
              src="assets/images/icons/filter.svg"
              (click)="toggleMarketingFilter()"
            />
          </div>
          <div
            *ngIf="showMarketingFilter"
            class="flex justify-between items-center input-container"
          >
            <div class="flex search-container">
              <mat-select
                [formControl]="marketingFilter"
                [multiple]="true"
                placeholder="Select channels"
              >
                <mat-option
                  *ngFor="let option of options_marketing"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </th>
      </ng-container> -->

          <!-- support strategy Column -->
          <ng-container matColumnDef="support_strategy">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0; padding: 0 5px !important"
            >
              <div
                [ngStyle]="{
                  'margin-bottom':
                    (!showQualifierSearch && qualifierFilter.value) ||
                    (!showStatementSearch && textFilter.value) ||
                    (!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '20px'
                      : null
                }"
              >
                <span style="display: flex; align-items: center">
                  Support Strategy
                </span>
              </div>
            </th>
            <!-- <td mat-cell *matCellDef="let element; let i = index">
              <div
                class="support-strategy-2lines"
                *ngIf="
                  element.support_strategy && element.support_strategy.trim();
                  else noSupportStrategy
                "
                (mouseenter)="
                  showTooltip($event, {
                    name: 'Support Strategy',
                    description: element.support_strategy
                  })
                "
                (mouseleave)="closeTooltip()"
                style="cursor: pointer"
              >
                {{ element.support_strategy }}
              </div>
              <ng-template #noSupportStrategy>
                <div class="support-strategy-2lines">
                </div>
              </ng-template>
            </td> -->

            <!-- to close tooltip (mouseleave)="closeTooltip()" -->
            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container
                *ngIf="
                  !element.isSupportStrategyEdited;
                  else supportStrategyEditorTpl
                "
              >
                <div
                  style="
                    position: relative;
                    width: 100%;
                    margin-top: 3px !important;
                  "
                >
                  <!-- (mouseenter)="
                      stripHtmlTags(element.support_strategy) &&
                        showTooltip($event, {
                          name: 'Support Strategy',
                          description: stripHtmlTags(element.support_strategy)
                        })
                    " -->
                  <textarea
                    #textAreaRef
                    matInput
                    class="support-strategy-edit"
                    (mouseenter)="
                      element.support_strategy &&
                        showTooltip($event, {
                          name: 'Support Strategy',
                          description: element.support_strategy
                        })
                    "
                    style="width: 100%; z-index: 1; margin-top: -1px !important"
                    maxlength="32000"
                    (click)="
                      element.editing_permission &&
                        enableSupportStrategyEditor(element)
                    "
                    [readonly]="!element.editing_permission"
                    [disabled]="!element.editing_permission"
                    [ngStyle]="{
                      cursor: !element.editing_permission
                        ? 'not-allowed'
                        : 'pointer'
                    }"
                    >{{ sanitizeHTML(element.support_strategy) }}</textarea
                  >
                </div>
              </ng-container>

              <ng-template #supportStrategyEditorTpl>
                <div style="width: 100%; margin-top: 3px">
                  <editor
                    [(ngModel)]="element.support_strategy"
                    apiKey="no-api-key"
                    licenseKey="gpl"
                    [init]="init"
                    class="editor-class"
                    (blur)="disableSupportStrategyEditor(element)"
                    [disabled]="!element.editing_permission"
                    [ngStyle]="{
                      cursor: !element.editing_permission
                        ? 'not-allowed'
                        : 'pointer'
                    }"
                  ></editor>
                </div>
              </ng-template>
            </td>
          </ng-container>
          <!-- substantiations -->
          <ng-container matColumnDef="substantiations">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0; padding: 0 10px !important"
            >
              <div
                [ngStyle]="{
                  'margin-bottom':
                    (!showQualifierSearch && qualifierFilter.value) ||
                    (!showStatementSearch && textFilter.value) ||
                    (!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '20px'
                      : null
                }"
              >
                Substantiations
              </div>
            </th>

            <td
              mat-cell
              *matCellDef="let element"
              style="min-width: 210px; max-width: 210px"
            >
              <div
                class="substantiation-chips-area"
                [ngStyle]="{
                    height: isTruncated ? '5em' : '5em',
                    overflow: isTruncated ? 'auto' : 'hidden',
                    resize: 'none',
                  }"
              >
                <ng-container
                  *ngFor="let subst of element.substantiations; let j = index"
                >
                  <span
                    class="subst-chip"
                    [ngClass]="subst.textColorClass"
                    *ngIf="subst.name"
                    [matTooltip]="
                      subst.substantiation_id || subst.description
                        ? getSubstantiationTooltip(subst)
                        : ''
                    "
                    matTooltipDisabled="!(subst.substantiation_id || subst.description)"
                    (mouseenter)="
                      (subst.substantiation_id || subst.description) &&
                        showTooltip($event, {
                          name: subst.name,
                          description: subst.description,
                          details: subst.details,
                          subtype: subst.subtype,
                          geography: subst.geography
                        })
                    "
                    (mouseleave)="closeTooltip()"
                    (click)="openSubstantiationLink(subst.link, $event)"
                    style="
                      cursor: pointer;
                      position: relative;
                      display: inline-flex;
                      align-items: center;
                    "
                  >
                    <span
                      class="subst-chip-text"
                      [ngClass]="subst.textColorClass"
                    >
                      <ng-container
                        *ngIf="
                          subst.description &&
                          subst.description.trim().length > 0
                        "
                      >
                        {{
                          subst.description.length > 10
                            ? (subst.description | slice : 0 : 10) + "..."
                            : subst.description
                        }}
                      </ng-container>
                      <ng-container
                        *ngIf="!subst.description && subst.substantiation_id"
                      >
                        {{
                          subst.substantiation_id.length > 10
                            ? (subst.substantiation_id | slice : 0 : 10) + "..."
                            : subst.substantiation_id
                        }}
                      </ng-container>
                    </span>

                    <!-- Show 'x' only for user-added substantiations  *ngIf="subst.isUserAdded" -->
                    <span class="subst-chip-close">
                      <img
                        src="assets/images/icons/close-icon.png"
                        [style.marginLeft.px]="
                          subst.description?.length > 10 ||
                          subst.substantiation_id?.length > 10
                            ? 0
                            : 3
                        "
                        style="height: 8px; width: 8px; margin-top: 2px"
                        alt="Remove"
                        [style.cursor]="
                          (element.substantiation_permission === 'add__v' &&
                            subst.isUserAdded) ||
                          element.substantiation_permission ===
                            'add__v/remove__v'
                            ? 'pointer'
                            : 'not-allowed'
                        "
                        (click)="
                          (element.substantiation_permission === 'add__v' &&
                            subst.isUserAdded) ||
                          element.substantiation_permission ===
                            'add__v/remove__v'
                            ? deleteSubstantiation(subst, element, j)
                            : null;
                          $event.stopPropagation()
                        "
                      />
                    </span>
                  </span>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <!-- <ng-template #deleteSubstDialog>
            <div class="delete-subst-dialog">
              <h3 class="delete-subst-dialog-title">
                Are you sure you want to delete this substantiation?
              </h3>
              <div class="delete-subst-dialog-subtitle">
                <strong>{{ substToDelete?.name }}</strong>
              </div>
              <div class="delete-subst-dialog-actions">
                <button
                  mat-stroked-button
                  class="btn-text-cancel"
                  (click)="closeDialog('cancel')"
                >
                  Cancel
                </button>
                <button
                  mat-stroked-button
                  class="btn-text-proceed"
                  (click)="closeDialog('confirm')"
                >
                  Confirm
                </button>
              </div>
            </div>
          </ng-template> -->
          <ng-template #deleteSubstDialog>
            <div class="delete-subst-dialog">
              <h3 class="delete-subst-dialog-title">
                Are you sure you want to remove this substantiation?
              </h3>

              <div class="delete-subst-dialog-subtitle">
                <strong>{{ substToDelete?.name }}</strong>
              </div>

              <!-- Show description if present -->

              <div
                class="delete-subst-dialog-description"
                *ngIf="substToDelete?.description"
                [matTooltip]="substToDelete?.description"
              >
                {{ substToDelete.description }}
              </div>

              <div class="delete-subst-dialog-actions">
                <button
                  mat-stroked-button
                  class="btn-text-cancel"
                  (click)="closeDialog('cancel')"
                >
                  Cancel
                </button>
                <button
                  mat-stroked-button
                  class="btn-text-proceed"
                  (click)="closeDialog('confirm')"
                >
                  Confirm
                </button>
              </div>
            </div>
          </ng-template>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0"
            ></th>
            <td mat-cell *matCellDef="let element">
              <!-- <img
                src="assets/images/icons/plus-icon.png"
                style="height: 25px; width: 17px; cursor: pointer"
                (click)="openDialog(element)"
                role="button"
                tabindex="0"
                alt="Add"
              /> -->
              <img
                src="assets/images/icons/plus-icon.png"
                style="height: 25px; width: 17px; cursor: pointer"
                [style.cursor]="
                  element.substantiation_permission === 'read__v'
                    ? 'not-allowed'
                    : 'pointer'
                "
                (click)="
                  (element.substantiation_permission === 'add__v' ||
                    element.substantiation_permission === 'add__v/remove__v') &&
                    openDialog(element)
                "
                role="button"
                tabindex="0"
                alt="Add"
              />
            </td>
          </ng-container>

          <!-- Label Column -->
          <!-- <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef>expand</th>
        <td mat-cell *matCellDef="let element">{{ element.Label }}</td>
      </ng-container> -->

          <!-- Expand Button Column -->
          <ng-container matColumnDef="expand">
            <th
              mat-header-cell
              *matHeaderCellDef
              sticky
              style="position: sticky; top: 0"
            >
              <!-- <div
                [ngStyle]="{
                  'margin-bottom':
                    (!showQualifierSearch && qualifierFilter.value) ||
                    (!showStatementSearch && textFilter.value) ||
                    (!showMarketingFilter && marketingFilter.value?.length > 0)
                      ? '15px'
                      : null
                }"
              >
                <img
                  src="assets/images/icons/arrow-expand.png"
                  style="
                    height: 16px;
                    width: 16px;
                    margin: 0 0px 0 3px;
                    max-width: 95%;
                  "
                />
              </div> -->
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <button
                mat-icon-button
                (click)="
                  Rowexpandandcollapse(element, i); $event.stopPropagation()
                "
                style="height: 16px; width: 16px; max-width: 95%"
              >
                <img
                  [src]="
                    expandedElements.has(element)
                      ? 'assets/images/icons/arrow-collapse.png'
                      : 'assets/images/icons/arrow-expand.png'
                  "
                  [alt]="expandedElements.has(element) ? 'Collapse' : 'Expand'"
                  style="height: 16px; width: 16px"
                  width="24"
                  height="24"
                />
              </button>
            </td>
          </ng-container>

          <!-- Expanded Content Row: Spans all columns and shows only when expanded -->

          <!-- Expanded Detail Row: Inner Table -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length"
            >
              <ng-container *ngIf="element.isExpansion">
                <div>
                  <div class="scroll-innertablecontainer">
                    <!-- *ngIf="isShowinnertableHeader" -->
                    <table
                      mat-table
                      *ngIf="expandedFilterMap.get(element.data)"
                      [dataSource]="expandedFilterMap.get(element.data) || []"
                      class="inner-table"
                    >
                      <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"> -->
                      <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef></th>

                        <td mat-cell *matCellDef="let row">
                          <!-- <mat-checkbox
                            (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                          >
                          </mat-checkbox> -->
                        </td>
                      </ng-container>

                      <!-- Substantiation Id Column -->
                      <ng-container matColumnDef="substantiation_id">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="width: 11% !important; top: auto !important"
                          appClickOutside
                          (clickOutside)="
                            expandedRowSearchState.get(
                              element.data
                            ).substantiationId = false
                          "
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;

                              /* width: 300px; */
                            "
                          >
                            <span
                              [ngClass]="{
                                'header-text-highlight': expandedRowFilters.get(
                                  element.data
                                )?.substantiationId.value
                              }"
                              >Substantiation Id</span
                            >
                            <img
                              src="assets/images/icons/search.svg"
                              alt="Search"
                              style="
                                width: 12px;
                                height: 12px;
                                margin-top: 3px;
                                cursor: pointer;
                              "
                              (click)="
                                toggleSubstantiationIdSearch(element.data)
                              "
                            />
                          </div>

                          <div
                            *ngIf="
                              expandedRowSearchState.get(element.data)
                                ?.substantiationId
                            "
                            class="flex justify-between items-center input-container"
                          >
                            <div
                              class="flex search-container-expand"
                              style="width: 100% !important"
                            >
                              <img src="assets/images/icons/search.svg" />
                              <input
                                #searchInput
                                type="text"
                                class="search-input"
                                placeholder="Search here..."
                                [formControl]="
                                  expandedRowFilters.get(element.data)
                                    ?.substantiationId
                                "
                                style="width: 7%"
                              />
                              <img
                                *ngIf="
                                  expandedRowFilters.get(element.data)
                                    ?.substantiationId.value
                                "
                                (click)="
                                  expandedRowFilters
                                    .get(element.data)
                                    ?.substantiationId.setValue('')
                                "
                                src="assets/images/icons/close-icon.png"
                                style="cursor: pointer"
                              />
                            </div>
                          </div>
                        </th>
                        <!-- <td mat-cell *matCellDef="let element; let i = index">
                        <span
                          style="
                            text-decoration: underline;
                            padding-left: 2px;
                            cursor: pointer;
                          "
                          >{{ element.substantiation_id }}</span
                        >
                      </td> -->
                        <td
                          mat-cell
                          *matCellDef="let element; let i = index"
                          style="padding-left: 5px"
                        >
                          <a
                            *ngIf="element.substantiation_link"
                            [href]="element.substantiation_link"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="
                              text-decoration: underline;
                              padding-left: 2px;
                              cursor: pointer;
                              color: #1f36c7;
                            "
                          >
                            {{ element.substantiation_id }}
                          </a>
                          <span
                            *ngIf="!element.substantiation_link"
                            style="padding-left: 2px; color: #49526e"
                          >
                            {{ element.substantiation_id }}
                          </span>
                        </td>
                      </ng-container>
                      <!--Description Column-->
                      <ng-container matColumnDef="description">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="
                            padding: 10px !important ;
                            top: auto !important;
                          "
                          appClickOutside
                          (clickOutside)="
                            expandedRowSearchState.get(
                              element.data
                            ).description = false
                          "
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              /* width: 300px; */
                            "
                          >
                            <span
                              [ngClass]="{
                                'header-text-highlight': expandedRowFilters.get(
                                  element.data
                                )?.description.value
                              }"
                              >Description</span
                            >
                            <img
                              src="assets/images/icons/search.svg"
                              alt="Search"
                              style="
                                width: 12px;
                                height: 12px;
                                margin-top: 3px;
                                cursor: pointer;
                              "
                              (click)="toggleDescriptionSearch(element.data)"
                            />
                          </div>

                          <!-- Statement Text
                  <mat-icon class="text-icon" (click)="toggleStatementSearch()"
                    >search</mat-icon
                  > -->

                          <div
                            *ngIf="
                              expandedRowSearchState.get(element.data)
                                ?.description
                            "
                            class="flex justify-between items-center input-container"
                          >
                            <div
                              class="flex search-container-expand"
                              style="width: 100% !important"
                            >
                              <img src="assets/images/icons/search.svg" />
                              <input
                                #searchInput
                                type="text"
                                class="search-input"
                                placeholder="Search here..."
                                [formControl]="
                                  expandedRowFilters.get(element.data)
                                    ?.description
                                "
                                style="width: 7% !important"
                              />
                              <img
                                *ngIf="
                                  expandedRowFilters.get(element.data)
                                    ?.description.value
                                "
                                (click)="
                                  expandedRowFilters
                                    .get(element.data)
                                    ?.description.setValue('')
                                "
                                src="assets/images/icons/close-icon.png"
                                style="cursor: pointer"
                              />
                            </div>
                          </div>
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element; let i = index"
                          [matTooltip]="element.description"
                        >
                          <span class="expand-text-alignment">{{
                            element.description
                          }}</span>
                        </td>
                      </ng-container>

                      <!-- Substantiation Details Column -->
                      <ng-container matColumnDef="substantiation_details">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="
                            top: auto !important;
                            padding-left: 15px !important;
                          "
                        >
                          <div><span>Substantiation Details</span></div>
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element; let i = index"
                          style="padding: 4px 15px !important"
                          [matTooltip]="element.substantiation_details"
                        >
                          <span class="expand-text-alignment">
                            {{ element.substantiation_details }}
                          </span>
                        </td>
                      </ng-container>

                      <!-- geography Channel Column -->
                      <ng-container matColumnDef="geography">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          appClickOutside
                          (clickOutside)="
                            expandedRowSearchState.get(
                              element.data
                            ).geography = false
                          "
                          style="top: auto !important"
                        >
                          <span
                            style="display: flex; align-items: center"
                            [ngClass]="{
                              'header-text-highlight':
                                expandedRowFilters.get(element.data)?.geography
                                  .value?.length > 0
                            }"
                          >
                            Geography
                            <img
                              src="assets/images/icons/Vector.svg"
                              class="geography-icon"
                              (click)="toggleGeographyFilter(element.data)"
                            />
                          </span>

                          <div
                            *ngIf="
                              expandedRowSearchState.get(element.data)
                                ?.geography
                            "
                          >
                            <!-- class="flex justify-between items-center input-container" -->
                            <div
                              class="flex search-container-expand"
                              style="width: 100% !important"
                            >
                              <mat-select
                                #geographyDropdown
                                [formControl]="
                                  expandedRowFilters.get(element.data)
                                    ?.geography
                                "
                                (closed)="
                                  onGeographyDropdownClosed(element.data)
                                "
                                [multiple]="true"
                                style="
                                  margin-top: 0px !important;
                                  padding-right: 2px !important;
                                "
                              >
                                <mat-option
                                  *ngFor="
                                    let option of rowGeographyOptions[
                                      element.data.slno
                                    ] || []
                                  "
                                  [value]="option"
                                  style="padding: 0px 10px"
                                >
                                  {{ option }}
                                </mat-option>
                                <!-- <mat-option
                                  *ngFor="
                                    let option of rowGeographyOptions[
                                      element.data
                                    ]
                                  "
                                  [value]="option"
                                >
                                  {{ option }}
                                </mat-option> -->
                              </mat-select>
                            </div>
                          </div>
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          style="padding-left: 8px"
                        >
                          <span>{{ element.geography }}</span>
                        </td>
                      </ng-container>

                      <!-- support strategy Column -->
                      <ng-container matColumnDef="subtype">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="top: auto !important"
                        >
                          <span style="display: flex; align-items: center">
                            Sub Type
                          </span>
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element; let i = index"
                          [matTooltip]="element.subtype"
                          style="padding-left: 8px"
                        >
                          <span>{{ element.subtype }}</span>
                        </td>
                      </ng-container>
                      <!-- substantiations -->
                      <ng-container matColumnDef="document_link">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="top: auto !important"
                        >
                          Document Link
                        </th>

                        <td
                          mat-cell
                          *matCellDef="let element; let i = index"
                          style="padding-left: 8px"
                        >
                          <a
                            *ngIf="element.document_link"
                            [href]="element.document_link"
                            class="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [matTooltip]="element.document_name"
                          >
                            <!-- {{ element.document_link }} -->
                            {{ element.document_name }}
                          </a>
                        </td>
                      </ng-container>

                      <!-- icon Column -->
                      <!-- Currently out of Scope do commenting out code -->
                      <!-- <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <img
                      src="assets/images/icons/shopping-cart.png"
                      style="height: 16px; width: 16px"
                      (click)="openDialog()"
                    />
                  </td>
                </ng-container> -->

                      <tr
                        [ngClass]="{ tablelayout: true, 'even-row': true }"
                        mat-header-row
                        *matHeaderRowDef="displayedColumns1"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="
                          let row;
                          let i = index;
                          columns: displayedColumns1
                        "
                        [ngClass]="{
                          tablelayout: true,
                          'odd-row': i % 2 !== 0,
                          'even-row': i % 2 === 0
                        }"
                        [attr.data-index]="i"
                      ></tr>
                    </table>
                  </div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <tr
            [ngClass]="{ tablelayout: true, 'even-row': true }"
            mat-header-row
            *matHeaderRowDef="displayedColumns"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              let i = index;
              columns: displayedColumns;
              when: isNotExpansionDetailRow
            "
            [ngClass]="{
              tablelayout: true,
              'odd-row': i % 2 !== 0,
              'even-row': i % 2 === 0
            }"
            [attr.data-index]="i"
          ></tr>
          <!-- 'claim-row': row.rowType === 'claim',
              'la-row': row.rowType === 'la', -->
          <!-- Expanded detail row for inner table -->

          <tr
            mat-row
            *matRowDef="
              let row;
              let i = index;
              columns: ['expandedDetail'];
              when: isExpansionDetailRow
            "
          ></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- <app-footer class="footer"></app-footer> -->
</div>
<p-toast position="bottom-right" key="br" />
<!-- <app-footer></app-footer> -->
